import { Injectable } from '@angular/core';
// import { Http } from '@angular/http'; // Old method update to httpclient
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { DataStateChangeEventArgs, Sorts, DataResult } from '@syncfusion/ej2-angular-grids';
import { Observable, map } from 'rxjs';
import { Subject } from 'rxjs';
import { environment } from './../../../environments/environment';

@Injectable()
export class DataService extends Subject<DataStateChangeEventArgs> {

 $api_get_url = environment.$api_get_url;
private BASE_URL = this.$api_get_url + '/api/system_log';

 

  constructor(private http: HttpClient) {
    super();
  }

  public execute(state: any): void {
    this.getData(state).subscribe(x => super.next(x));
  }

  protected getData(state: DataStateChangeEventArgs): Observable<DataStateChangeEventArgs> {
    const pageQuery = `$skip=${state.skip}&$top=${state.take}`;
    let sortQuery = '';
    const d = 'd';
    const results = 'results';
    const count = '__count';
    if ((state.sorted || []).length) {
      sortQuery = `&$orderby=` + state.sorted.map((obj: Sorts) => {
        return obj.direction === 'descending' ? `${obj.name} desc` : obj.name;
      }).reverse().join(',');
    }

    return this.http
      //.get(`${this.BASE_URL}?${pageQuery}${sortQuery}&$inlinecount=allpages&$format=json`)
      .get(`${this.BASE_URL}`)

      .pipe(map((response: any) => response.json()))

     .pipe(map((response: any) => ({
         result: [results],
      count: parseInt(response[count], 10)
       } as DataResult)))

      .pipe((data: any) => data);
  }
}